import { ContentType, ContentV2 } from '@front-app/services/GroupsApi/DiscussionModel';

/**
 * Expects a video id such as `iik25wqIuFo`
 * OR a video url in the form: `https://www.youtube.com/watch?v=iik25wqIuFo`
 */
export function getIdFromUrlOrId(idOrUrl: string): string | null {
	try {
		const url = new URL(idOrUrl);
		return url.searchParams.get('v') || idOrUrl;
	} catch (e) {
		return idOrUrl;
	}
}

export enum VideoProvider {
	UNKNOWN = 'unknown',
	YOUTUBE = 'youtube',
	VIMEO = 'vimeo',
}

// Both Vimeo and YouTube have canonical hostnames,
// ie: they redirect to this URL. So if users are copy/pasting
// all their URLs should match these ones.
const CANONICAL_YOUTUBE_HOSTNAME = 'www.youtube.com';
export const SHORTENED_YOUTUBE_HOSTNAME = 'youtu.be';
const CANONICAL_VIMEO_HOSTNAME = 'vimeo.com';
const VIMEO_PLAYER_HOSTNAME = 'player.vimeo.com';

export function detectVideoProvider(videoUrl: string): VideoProvider | null {
	try {
		const hostname = new URL(videoUrl).host;
		if (hostname === CANONICAL_YOUTUBE_HOSTNAME || hostname === SHORTENED_YOUTUBE_HOSTNAME) {
			return VideoProvider.YOUTUBE;
		}
		if (hostname === CANONICAL_VIMEO_HOSTNAME || hostname === VIMEO_PLAYER_HOSTNAME) {
			return VideoProvider.VIMEO;
		}
	// eslint-disable-next-line no-empty
	} catch (e) {}
	return null;
}

export function checkIfEmbeddedVideo(content: ContentV2) {
	if (
		!content
		|| content.type === ContentType.DISCUSSION
		|| content.type === ContentType.FILE
		|| !content.metadata
		|| !content.metadata.url
	) {
		return false;
	}

	const detectedProvider = detectVideoProvider(content.metadata.url);
	if (detectedProvider === VideoProvider.YOUTUBE || detectedProvider === VideoProvider.VIMEO) {
		return true;
	}
	return false;
}
